<template>
  <div class="container-fluid bg-body">
    <Nav></Nav>
    <ChatWindow></ChatWindow>
    <ChatForm></ChatForm>
  </div>
</template>

<script>
import Nav from "@/components/Nav";
import {watch} from "vue";
import getUser from "@/composables/getUser";
import {useRouter} from "vue-router";
import ChatForm from "@/components/ChatForm";
import ChatWindow from "@/components/ChatWindow";

export default {
  name: "ChatRoomView",
  components: {ChatWindow, ChatForm, Nav},
  setup(){
    let {user} = getUser();
    let router = useRouter();
    watch(user, ()=>{
      if (!user.value){
        router.push({name: 'welcome'});
      }
    })
  }
}
</script>

<style scoped>

</style>